import Cookies from 'js-cookie'
import Tools from "@/utils/tools";

const TokenKey = 'Authorization'

let auth = {};

auth.getToken = function() {
  return Cookies.get(TokenKey)
};

auth.setToken = function(token) {
  return Cookies.set(TokenKey, token)
};

auth.removeToken = function() {
  Tools.loginUser = undefined
  return Cookies.remove(TokenKey)
};

auth.check = function(server) {
  let userid = localStorage.getItem("userid");
  let roleids = localStorage.getItem("roleids").split(",")

  if (userid == 'admin') { //超级管理员不控制权限
    return true;
  }
  if(roleids.includes('0')) {
    return true;
  }

  let servers = localStorage.getItem("servers");
  return servers.indexOf(server) != -1;
}

export default auth;



// WEBPACK FOOTER //
// ./src/utils/auth.js